<template>
    <b-modal ref="mdlEditPaiRuoli" :title="title" centered no-close-on-backdrop no-close-on-esc hide-header-close size="lg">
        <b-row>
            <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                <label class="sa-label-data">Ruolo</label>
                <b-form-input v-model="jsonDataRuoloPai.ruolo"></b-form-input>
            </b-col>

            <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                <label class="sa-label-data">Tipologia di Accesso</label>
                <b-form-select v-model="jsonDataRuoloPai.tipologiaAccesso" :options="tipologiaAccessoOptions" :value="''" value-field="value" text-field="text">
                    <template #first>
                        <b-form-select-option :value="null" disabled>- Seleziona Tipologia Accesso -</b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>
        </b-row>

        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Descrizione</label>
                <b-form-textarea v-model="jsonDataRuoloPai.descrizione" max-rows="10" rows="7"></b-form-textarea>
            </b-col>
        </b-row>
        <template #modal-footer>
            <b-button @click="onCloseModal" variant="outline-danger" size="md">Annulla</b-button>
            <b-button @click="onClickRuoloPaiSave" variant="outline-success" size="md">Salva</b-button>
        </template>

        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
export default {
    mixins: [UtilityMixin],
    components: { ModalError },
    data() {
        return {
            title: null,
            pathResourcePaiRuoli: "/rsapairuoli",
            tipologiaAccessoOptions: [
                { text: "FARMACI", value: "FARMACI" },
                { text: "ICD-IX", value: "ICD-IX" },
                { text: "ICD-X", value: "ICD-X" },
                { text: "Nomenclatore", value: "NOMENCLATORE" },
                { text: "TESTO LIBERO", value: "TESTO LIBERO" },
            ],
            jsonDataRuoloPai: {
                id: null,
                ruolo: null,
                tipologiaAccesso: null,
                descrizione: null,
            },
        };
    },

    methods: {
        show(jsonData) {
            let me = this;
            me.jsonDataRuoloPai = jsonData;
            me.title = !jsonData.id ? "Nuovo Ruolo" : "Modifica Ruolo";
            //console.log("ITEM", jsonData);
            me.$refs.mdlEditPaiRuoli.show();
        },

        onCloseModal() {
            let me = this;
            me.jsonDataRuoloPai = {};
            me.$refs.mdlEditPaiRuoli.hide();
            me.$emit("closeModal");
        },
        onClickRuoloPaiSave() {
            let me = this;
            UtilityMixin.methods.saveResource(me.pathResourcePaiRuoli, me.jsonDataRuoloPai, me.ruoloPaiSuccessSave, me.ruoloPaiErrorSave);
        },
        ruoloPaiSuccessSave(response) {
            let me = this;
            me.$emit("ruoloPaiSave", response);
            me.$refs.mdlEditPaiRuoli.hide();
            me.$bvToast.toast("Salvataggio avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        ruoloPaiErrorSave(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },

        deleteRuoloPai(id) {
            let me = this;
            UtilityMixin.methods.deleteResource(me.pathResourcePaiRuoli + "/" + id, null, me.deleteRuoloPaiSuccess, me.deleteRuoloPaiError);
        },
        deleteRuoloPaiSuccess(response) {
            let me = this;
            me.$emit("ruoloPaiDelete", response);
            me.$bvToast.toast("Eliminazione avvenuta con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        deleteRuoloPaiError(response) {
            let me = this;
            me.$emit("ruoloPaiDelete", response);
            me.$bvToast.toast("Errore durante l'eliminazione", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        onDeleteRuoloPai(item) {
            let me = this;
            me.$bvModal
                .msgBoxConfirm("Sei sicuro di eliminare questo ruolo?", {
                    title: "Eliminazione Ruolo PAI",
                    buttonSize: "sm",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    okVariant: "danger",
                    cancelVariant: "secondary",
                    hideHeaderClose: true,
                    footerClass: "p-2",
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteRuoloPai(item.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    },
};
</script>
